import tw, { styled, css } from "twin.macro";

export const Wrapper = styled.div`
	.hide-scrollbar {
		-ms-overflow-style: none !important; /* IE and Edge */
		scrollbar-width: none !important;
		&::-webkit-scrollbar {
			display: none !important;
		}
	}
`;

export const active = (props) => css`
	${tw`text-appPink! bg-white text-xs md:text-base font-semibold shadow w-full rounded-xl p-4 md:p-3 border-none transition-all ease-in-out delay-1000`}
	font-family: Poppins;
	line-height: 12px;
	letter-spacing: 0.5px;
`;
export const inactive = (props) => css`
	${tw`text-appTextDark! bg-transparent! text-xs md:text-base font-semibold  w-full rounded-xl p-4 md:p-3 border-none transition-all ease-in-out delay-1000`}
	font-family: Poppins;
	line-height: 12px;
	letter-spacing: 0.5px;
`;
